import { InputAdornment, TextField, ThemeProvider, Tooltip, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { createSeencTheme } from 'src/theme/seenc';

SeencTextInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  inputRef: PropTypes.object,
  required: PropTypes.bool,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  maxLength: PropTypes.number,
  inputMode: PropTypes.string,
  fullWidth: PropTypes.bool,
  adornmentWidth: PropTypes.number,
  autoFocus: PropTypes.bool,
  concatValueIntoTooltip: PropTypes.bool,
  props: PropTypes.object,
};

export default function SeencTextInput({
  id,
  name,
  label,
  placeholder,
  disabled,
  inputRef,
  required,
  value,
  onChange,
  onBlur,
  maxLength,
  inputMode,
  type = 'text',
  sx = {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    verticalAlign: 'middle',
  },
  fullWidth = true,
  autoFocus = false,
  concatValueIntoTooltip = false,
  adornmentWidth,
  trackAdornmentWidth = false,
  ...props
}) {
  const { InputProps: _removedInputProps, inputProps: _removedinputProps, ...rest } = props;
  const seencTheme = createSeencTheme();
  return (
    <ThemeProvider theme={seencTheme}>
      <Tooltip
        title={
          value ?
            concatValueIntoTooltip ?
              `${placeholder || label}: ${value}`
            : placeholder || label
          : ''
        }>
        <TextField
          id={id}
          name={name}
          placeholder={placeholder}
          disabled={disabled}
          inputRef={inputRef}
          required={required}
          value={value || ''}
          onChange={onChange}
          onBlur={onBlur}
          inputProps={{
            maxLength: maxLength,
            inputMode: inputMode || 'text',
            inputRef: inputRef,
            type: type,
            ...props.inputProps,
          }}
          InputProps={{
            sx: sx,
            startAdornment:
              label ?
                <InputAdornment
                  position='start'
                  sx={{
                    width: adornmentWidth ? `${adornmentWidth + 12 * 1.6}px` : undefined,
                    minWidth: adornmentWidth ? `${adornmentWidth + 12 * 1.6}px` : undefined,
                    maxWidth: adornmentWidth ? `${adornmentWidth + 12 * 1.6}px` : undefined,
                  }}>
                  <Typography
                    variant='seenc_default'
                    attr={trackAdornmentWidth ? 'track-adornment-width' : undefined}>
                    {label}:
                  </Typography>
                </InputAdornment>
              : undefined,
            ...props.InputProps,
          }}
          variant='outlined'
          fullWidth={fullWidth}
          autoFocus={autoFocus}
          {...rest}
        />
      </Tooltip>
    </ThemeProvider>
  );
}
